import Grid from "@mui/material/Grid2";
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";

interface IProps {
    action: string;
    setAction: (value: string) => void;
    extractMode: string;
    setExtractMode: (value: string) => void;
    exportMode: string;
    setExportMode: (value: string) => void;
}
export default function ExtractionTableOptions({ action, setAction, extractMode, setExtractMode, exportMode, setExportMode }: IProps) {

    const compactLabel = { fontSize: "0.87em", marginBottom: "1px" };
    const compactRow = { margin: 0, minHeight: "26px" };
    const compactRadio = { p: 0.25, mr: 1 };

    return (
        <Grid container spacing={2} size={6}>
            {/* 2 */}
            <FormControl sx={{ mr: 2 }}>
                <FormLabel sx={compactLabel}>Action</FormLabel>
                <RadioGroup
                    value={action}
                    onChange={e => setAction(e.target.value)}
                >
                    <FormControlLabel
                        value="all"
                        control={<Radio size="small" sx={compactRadio} />}
                        label="Extract All Data Displayed Here"
                        sx={compactRow}
                    />
                    <FormControlLabel
                        value="highlighted"
                        control={<Radio size="small" sx={compactRadio} />}
                        label="Extract Only Highlighted Survey"
                        sx={compactRow}
                    />
                    <FormControlLabel
                        value="csv"
                        control={<Radio size="small" sx={compactRadio} />}
                        label="Export All Data Displayed Here Now to CSV"
                        sx={compactRow}
                    />
                </RadioGroup>
            </FormControl>
            {/* 3 */}
            {action === "highlighted" &&
                <FormControl sx={{ mr: 2 }}>
                    <FormLabel sx={compactLabel}>Extract Mode</FormLabel>
                    <RadioGroup
                        value={extractMode}
                        onChange={e => setExtractMode(e.target.value)}
                    >
                        <FormControlLabel
                            value="counts"
                            control={<Radio size="small" sx={compactRadio} />}
                            label="Mode Counts"
                            sx={compactRow}
                        />
                        <FormControlLabel
                            value="purpose"
                            control={<Radio size="small" sx={compactRadio} />}
                            label="Journey Purpose"
                            sx={compactRow}
                        />
                        <FormControlLabel
                            value="origins"
                            control={<Radio size="small" sx={compactRadio} />}
                            label="Origins"
                            sx={compactRow}
                        />
                    </RadioGroup>
                </FormControl>
            }
            {action === "csv" &&
                <FormControl sx={{ mr: 2 }}>
                    <FormLabel sx={compactLabel}>Export Mode</FormLabel>
                    <RadioGroup
                        value={exportMode}
                        onChange={e => setExportMode(e.target.value)}
                    >
                        <FormControlLabel
                            value="site/survey"
                            control={<Radio size="small" sx={compactRadio} />}
                            label="Site/Survey Details"
                            sx={compactRow}
                        />
                        <FormControlLabel
                            value="counts"
                            control={<Radio size="small" sx={compactRadio} />}
                            label="Counts Only"
                            sx={compactRow}
                        />
                    </RadioGroup>
                </FormControl>
            }
        </Grid>
    );
}